import React, { useState } from 'react';
import './FAQAccordion.css';

const FAQAccordion = ({ items }) => {
  const [openIndex, setOpenIndex] = useState(null);

  const handleToggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="faq-accordion">
      {items.map((item, index) => {
        const isOpen = openIndex === index;
        return (
          <div className={`faq-item ${isOpen ? 'faq-item--open' : ''}`} key={index}>
            <div className="faq-question" onClick={() => handleToggle(index)}>
              <span className="faq-question-text">{item.question}</span>
              <svg className="faq-chevron" width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M4 6L8 10L12 6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <div className="faq-answer">
              <div className="faq-answer__content">{item.answer}</div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default FAQAccordion;
